import { render } from "./ResponsibleView.vue?vue&type=template&id=091d41f0&scoped=true"
import script from "./ResponsibleView.vue?vue&type=script&lang=js"
export * from "./ResponsibleView.vue?vue&type=script&lang=js"

import "./ResponsibleView.vue?vue&type=style&index=0&id=091d41f0&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091d41f0"]])

export default __exports__